import { render, staticRenderFns } from "./Moveable.vue?vue&type=template&id=40b16a0a&lang=pug&"
import script from "./Moveable.vue?vue&type=script&lang=js&"
export * from "./Moveable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports